import React, { useCallback, useEffect, useState } from "react";

import { loginAction } from "../../Store/Actions/AuthActions";
import { showToast } from "../../utils/helper";
import { trackEvent } from "../../utils/analytics";
import { REACT_APP_GOOGLE_CLIENT_ID } from "../../utils/env";
import { useDispatch } from "react-redux";

interface GoogleLoginBtnType {
  onSuccess?: Function | null;
}

const GoogleLoginBtn: React.FC<GoogleLoginBtnType> = ({ onSuccess = null }) => {
  const dispatch = useDispatch();

  const [socialLoginLoader, setSocialLoginLoader] = useState<boolean>(false);

  const loginWithGoogle = useCallback((response: any) => {
    if (response && response.credential) {
      setSocialLoginLoader(true);

      trackEvent("web_login_submit", { method: "google" });

      loginAction(
        { type: "google", idtoken: response.credential, device_type: "web" },
        dispatch
      )
        .then((res) => {
          if (res && res.type === "success") {
            trackEvent("web_login_success", { method: "google" });
            showToast("success", res.message);
            if (onSuccess) onSuccess();
          } else {
            trackEvent("web_login_failed", { method: "google" });
            showToast("error", (res && res.message) || "Could not sign in with Google");
          }
        })
        .catch((err) => {
          trackEvent("web_login_failed", { method: "google" });
          showToast("error", err.message);
        })
        .finally(() => setSocialLoginLoader(false));
    } else {
      trackEvent("web_login_failed", { method: "google" });
      showToast("error", "Failed to login with Google. Please try again.");
    }
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: REACT_APP_GOOGLE_CLIENT_ID,
          callback: loginWithGoogle,
        });

        window.google.accounts.id.renderButton(
          document.getElementById("googleSignInButton"),
          {
            theme: "outline",
            size: "large",
            width: "100%",
            text: "signin_with",
          }
        );
      }
    };

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <>
      {socialLoginLoader && (
        <div className="text-center mt-2">
          <i className="fas fa-spinner fa-spin text-white" />
        </div>
      )}

      {!socialLoginLoader && (
        <div
          id="googleSignInButton"
          className="m-2 d-flex justify-content-center"
        ></div>
      )}
    </>
  );
};

export default GoogleLoginBtn;
